<template>
  <div class="footer">
    <!-- <div class="row card-notes" v-if="methodId === 'cp-cards'">
      <div class="column">
        {{ labels['card-notes'] }}
      </div>
    </div> -->
    <!-- <div class="row apple-pay">
      <div class="column">
        {{ labels['apple-pay'] }}
      </div>
    </div>
    <div class="row">
      <div class="column psp">
        <img :src="require('../../assets/psps.png')" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LABELS } from '@/settings'

export default {
  computed: mapState({
    labels: state => LABELS[state.language],
    methodId: state => state.donation.method
  })
}
</script>

<style scoped>
  .oi-donation-form .footer .row {
    display: flex;
    justify-content: center;
    flex-direction: row!important;
    margin-bottom: 5px;
    -webkit-filter: grayscale(1);
    filter: grayscale(1);
  }
  .oi-donation-form .footer .row .psp {
    flex: 0 0 30%;
    max-width: 30%;
  }
  .oi-donation-form .footer .apple-pay,
  .oi-donation-form .footer .card-notes {
    font-size: 12px;
    text-align: center;
  }
</style>
